import { Component, Input, OnInit } from '@angular/core'
import { FormFieldComponent } from '../form-field/form-field.component'
import { RadioFieldProvider } from './radio-field-provider'

@Component({
  selector: 'bdg-radio-field',
  templateUrl: './radio-field.component.html',
  styleUrls: ['./radio-field.component.scss'],
})
export class RadioFieldComponent<T extends { id: number | string }> extends FormFieldComponent implements OnInit {
  @Input()
  provider: RadioFieldProvider<T>
  @Input()
  disposition: 'row' | 'column'
  @Input()
  radioItemClass = ''

  displayClass: string
  radioClass: string

  constructor() {
    super()
  }

  ngOnInit(): void {
    this.displayClass = 'd-flex flex-wrap' + (this.disposition === 'column' ? ' flex-column' : '')
    this.radioClass = (this.disposition === 'column' ? 'verticalRadio ' : 'horizontalRadio ') + this.radioItemClass
  }

  isChecked = (value: T) => {
    return this.provider.compareWith(this.control.value, value)
  }
}
